import { flattenTagsToDepth } from "@helpers/content/tag";
import type { SectionTag } from "@memorang/ui/components/FilterSections/types";

export const resolveSummaryTopics = ({
	sectionTags,
	maxFilterDepth,
}: {
	sectionTags: SectionTag[] | undefined;
	maxFilterDepth: number;
}): string[] =>
	flattenTagsToDepth(
		sectionTags?.flatMap((section) => section.tags) ?? [],
		maxFilterDepth,
	)
		.filter((tag) => !tag.locked)
		.map(({ title }) => title);
